/** @format */

import TRANSLATIONS_ENG from './eng.json';

export function WidgetI18nConfig($translateProvider, Languages) {
    'ngInject';

    $translateProvider.translations(Languages.eng, TRANSLATIONS_ENG);
}
